module.exports = __webpack_public_path__ + "static/media/img2-3.fc0bdfab.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/banano/nutricheck_suelo/P/img2-3.png
// module id = 1245
// module chunks = 3